function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { ApiContext } from '../context.js';
import PropTypes from 'prop-types';
function TabsComponent(deps, props, ref) {
  var openTabIDs = props.openTabIDs,
    selectedTabID = props.selectedTabID;
  var _deps = deps(React.useContext(ApiContext)),
    TabsPropsManager = _deps.TabsPropsManager,
    Tab = _deps.Tab;
  return /*#__PURE__*/React.createElement("ul", _extends({}, TabsPropsManager(props), {
    ref: ref || null
  }), openTabIDs.map(function (id) {
    return /*#__PURE__*/React.createElement(Tab, {
      key: id,
      id: id,
      selectedTabID: selectedTabID
    });
  }));
}
export default TabsComponent;